<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication-1" id="dedication-1">
<p class="centerImage"><img alt="images" id="img1" src="images/img1.jpg"/></p>
<p class="caption">Commission certificate appointing Albert Fensch as National Aide-de-Camp of the National Indian War Veterans and signed by Commander-in-Chief John H. Brandt in Los Angeles, 1925. Editor's Collection.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_dedication1.vue?80bc6b92